import { createContext } from 'react';
export const RouteContext = createContext({});

export const DataContext = createContext({
  conceptName: '',
  startTimeApp: 0,
  btnPlansAvailable: null
});
